import { log } from './shared';

/**
 * Зарегистрировать (или получить) активный SW и дождаться активации.
 * Firebase-независим — используется обоими провайдерами (fcm/pushme).
 */
export async function getActiveSwRegistration(): Promise<ServiceWorkerRegistration> {
    if (!('serviceWorker' in navigator)) {
        throw new Error('Service Worker is not supported in this browser');
    }

    // eslint-disable-next-line init-declarations
    let registration: ServiceWorkerRegistration;
    try {
        // eslint-disable-next-line compat/compat
        registration = await navigator.serviceWorker.register('/firebase-messaging-sw.js');
    } catch (error) {
        log('Service worker registration failed', error);
        throw error;
    }

    if (registration.active) {
        return registration;
    }

    const worker = registration.installing || registration.waiting;

    if (worker) {
        await new Promise<void>((resolve, reject) => {
            worker.addEventListener('statechange', () => {
                if (worker.state === 'activated') {
                    resolve();
                } else if (worker.state === 'redundant') {
                    reject(new Error('Service worker installation failed: redundant state'));
                }
            });
        });
    }

    return registration;
}
